
<vsf-layout ngSkipHydration>
    <vsf-layout-header></vsf-layout-header>
    <vsf-assistant></vsf-assistant>

    <vsf-collections-menu-mobile [visible]="mobileNavVisible$ | async" class="z-10"></vsf-collections-menu-mobile>
    <!-- <vsf-shop-by-mobile class="z-10" [visible]="mobileFiltersVisible$ | async" [collections]="topCollections$ | async" ></vsf-shop-by-mobile> -->
    <vsf-cart-drawer (close)="closeCartDrawer()" [visible]="cartDrawerVisible$ | async"></vsf-cart-drawer>
    
    <div class="text-black max-w-[1600px] mx-auto bg-surface">
        @if ((isHomePage$ | async)) {
            <vsf-home-page></vsf-home-page>
        } @else {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Mobile bottom navigation -->
    <vsf-mobile-bottom-nav></vsf-mobile-bottom-nav>

    <vsf-layout-footer></vsf-layout-footer>
</vsf-layout>
